import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import moment from "moment";
import apiService from "../../api/api.service";

import telematicsService from "../../api/telematics.service";
import smsServiceNew from "../../api/reservePlanNew.service";
import rules from "../../utils/rules";
import config from "../../../secrets/config";
import app from "@/utils/app.json";

export default {
  name: "on-rent-report",
  components: { pageheader },
  data() {
    return {
      configdata: config.ENABLE_ACCESS_CODE,
      usersList: [],
      isLoaderUser: false,
      selectedUser: "",
      showTable: false,
      errorMSG: "",
      actionsValid: true,
      rules: rules,
      monthlyListDropDown: app.monthlylistdropdown,
      selectMonthlyDay: null,
      selected: [
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Access Control Codes",
        "Search Field",
      ],
      filterTypes: [
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "7", name: "Access Control Codes" },
        { id: "9", name: "Search Field" },
      ],
      filterTypesWithoutAccess: [
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "9", name: "Search Field" },
      ],
      selectedOwnershipType: ["1", "2"],
      selectedOwnershipFinal: "",
      ownershipTypes: [
        { name: "Equipment on rent", value: "1" },
        { name: "Assets", value: "2" },
      ],
      selectedGroup: [],
      selectedGroupCount: "",
      groups: [],
      selectedMachine: [],
      selectedMachineCount: "",
      machines: [],
      menu1: false,
      menu2: false,
      fromDate: "",
      toDate: "",
      valid: true,
      closeOnContentClick: false,
      groupSearchFilter: "",

      machineSearchFilter: "",
      locationMenu: false,
      selectedLocation: "",
      selectedLocationCount: "",
      locations: [],
      loadinglocations: false,
      selectedModel: [],
      selectedModelCount: "",
      modelSearchFilter: "",
      jobSiteSearchFilter: "",
      models: [],
      loadingmodel: false,
      zonesList: [],
      selectedZone: [],
      zoneSearchFilter: "",
      menufilter: false,
      selectedJobSite: [],
      input: {},
      search: "",
      show1: false,
      searchField: "",
      searchContractId: "",
      searchMenu: false,
      isReportLoading: false,
      isReportExporting: false,
      selectedExportOption: null,
      exportOptions: ["Excel", "PDF"],
      isDownloading: false,
      loading: false,
      reportDataList: [],
      header: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        { text: "Equipment #", value: "stockKey" },
        { text: "Equipment", value: "name" },
        { text: "Telematics SN", value: "tuSerialNumber" },
        { text: "Customer Name", value: "customerName" },
        { text: "Contract#", value: "contractId" },
        { text: "Item Status", value: "itemStatus" },
        { text: "Quantity", value: "quantity" },

        { text: "Start Date", value: "initialContractDate" },
        { text: "Estimated Return Date", value: "contractEndDate" },
        { text: "PO#", value: "customerPurchaseOrder" },
        { text: "Job#", value: "customerJobNumber" },
        { text: "Ordered By", value: "orderedBy" },
        { text: "Picked Up by", value: "pickedUpBy" },
        { text: "Model", value: "model" },
        { text: "Jobsite", value: "jobSite" },
        { text: "Last GPS Address", value: "lastAddress", width: "200px" },
        { text: "Actions", value: "actionIcon" },
      ],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "100",
          count: 100,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      modelsList: [],
      isCreating: false,
      selectedAccessControlCodesNames: [],
      //access
      selectedAccessControlCodes: [],
      selectedAccessControlCodesCount: "",
      accessControlCodesSearchFilter: "",
      accessControlCodes: [],
      loadingaccesscontrolcodes: false,
      //end
      actionsDialog: false,
      dialogTitle: "",
      extendrentaldate: "",
      extendThroughMenu: false,
      callOffRentMenu: false,
      calloffdate: "",
      movejobsitedate: "",
      moveOnMenu: false,
      movejobsitenewnum: "",
      serviceOnMenu: false,
      requestmaintenancedate: "",
      requestMaintenanceContact: "",
      requestMaintenanceContactPhone: "",
      selectedItem: {
        extendrental: false,
        extendrentaldate: "",
        calloffrent: false,
        calloffdate: "",
        movejobsite: false,
        movejobsitedate: "",
        movejobsitenewnum: "",
        requestmaintenance: false,
        requestmaintenancecontact: "",
        requestmaintenancecontactphone: "",
        requestmaintenancedate: "",
      },
      requestCount: 0,
      isSendEmail: false,
      showDialog: false,
      toRoute: "",
      externalDate: "",
      callOffDate: "",
      moveJobSiteDate: "",
      maintenanceDate: "",
      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",

      searchemail: null,
      searchemailalerts: null,
      emailitems: [],
      alertemailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },
        { text: "Name", value: "name", width: "10px" },

        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },

        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],

      Alertsheader: [
        { text: "Company", value: "customerName", width: "10px" },
        { text: "Name", value: "name", width: "10px" },

        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel", "PDF"],
      scheduledType: "",
      selectedcust: "",
      selectedcustalert: "",
      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      groupSearchFilterSchedule: "",
      accessControlCodesSearchFilterSchedule: "",
      searchFieldSchedule: "",
      searchSchedule: "",
      searchAlerts: "",
      ScheduleReportName: "ONRENTREPORT",
      AlertsReportName: "ONRENTALERTREPORT",
      searchMenuSchedule: false,
      selectedschedule: {},
      selectedalerts: {},
      scheduleedit: false,
      alertsedit: false,
      selectedZonesNamesSchedule: [],
      selectedJobSiteNamesSchedule: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      isdeletealerts: false,
      scheduleformvalid: true,
      alertsformvalid: true,
      isSaveScheduleLoading: false,
      isSaveAlertsLoading: false,
      isupdateScheduleLoading: false,
      isupdateAlertsLoading: false,

      scheduleName: "",
      alertName: "",

      scheduledList: [],
      AlertsList: [],
      isScheduledListLoading: false,
      isAlertsListLoading: false,
      AlertsWeekDaysList: [
        {
          name: "Equipment Due Back in 1 Days",
          value: "1",
        },
        {
          name: "Equipment Due Back in 3 Days",
          value: "3",
        },
        {
          name: "Equipment Due Back in 5 Days",
          value: "5",
        },
      ],
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],
      selectedDays: [],
      selectedalertsdays: [],
      // end scheduled reports data fields
      displayAlertsForm: false,
      alertsdialog: false,
      selectedEquipments: [],
    };
  },
  watch: {
    emails(val, prev) {
      if (val.length === prev.length) return;
      this.emails = val.map((v) => {
        return v;
      });
    },
    alertsemails(val, prev) {
      if (val.length === prev.length) return;
      this.alertsemails = val.map((v) => {
        return v;
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.toRoute = to.name;
    if (this.selectedEquipments.length <= 0) {
      next();
    } else {
      this.showDialog = true;
    }
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsUserId",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.reportDataList.length
        : (this.pageNumber - 1) * this.pageSize + this.reportDataList.length;
    },
  },
  mounted() {
    this.input = utils.getInputContent("onRentReport", this.roles);
    if (
      this.$store.getters.companyIdDropdown == null ||
      this.$store.getters.companyIdDropdown == "" ||
      this.$store.getters.companyIdDropdown == undefined
    ) {
      this.errorMSG = "Please select customer to run the report";
      this.showTable = false;
    } else {
      this.errorMSG = "";
      this.showTable = true;
      this.getGroups();
      this.getMachines();
      this.getLocations();
      this.getModels();
      this.getZones();
      this.getAccessControlCodes();
      this.readReportListFromAPI();
    }
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        let date = value.split("T")[0];
        return moment(date).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  methods: {
    disablePastDates(val) {
      return val >= new Date().toISOString().substr(0, 10);
    },
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    joinOrEmpty(list, encode = false) {
      if (list.length > 0) {
        const value = list.join(",");
        return encode ? encodeURIComponent(value) : value;
      }
      return "";
    },
    computeOwnershipFinal(ownershipType) {
      return ownershipType.length == 0 || ownershipType.length == 2
        ? "0"
        : ownershipType[0];
    },
    triggerDownload(response, fileName, mimeType) {
      const url = window.URL.createObjectURL(
        new Blob([response], { type: mimeType })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      // deferred a tick: revoking in the same tick as click() can abort the
      // download in Firefox and Safari
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
      this.isDownloading = false;
    },
    async readUsersFromAPI() {
      let customerId =
        this.companyNameDropdown == "All" ||
        this.companyNameDropdown == "" ||
        this.companyNameDropdown == null
          ? ""
          : String(this.companyIdDropdown);

      try {
        let usersListRes;
        this.isLoaderUser = true;
        if (customerId == "") {
          usersListRes = await apiService.getUsersAll();
        } else {
          usersListRes = await apiService.getUsersByCustId(customerId);
        }
        if (usersListRes) {
          this.isLoaderUser = false;
          this.usersList = usersListRes.data.map((d, index) => ({
            ...d,
            name: d.firstName + " " + d.lastName,
            sno: index + 1,
          }));
        }
      } catch (err) {
        this.$toast.error("Unable to load the users" + err);
        this.isLoaderUser = false;
      }
    },
    async getAccessControlCodes() {
      try {
        this.loadingaccesscontrolcodes = true;
        let owrtype, id;
        let cust;
        if (
          this.companyIdDropdown == "" ||
          this.companyIdDropdown == null ||
          this.companyIdDropdown == undefined
        ) {
          cust = "All";
          id = "";
        } else {
          cust = this.$store.getters.companyIdDropdown;
          id = this.$store.getters.companyIdDropdown;
        }
        if (cust == "All") {
          owrtype = "1";
        } else {
          owrtype = "2";
        }
        let response = await telematicsService.getAccessKeysList(id, owrtype);
        if (response && response.data) {
          this.accessControlCodes = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              serialNumber: item.serialNumber ? item.serialNumber : "",
              accesscontrolcode: String(index),
              showCodeName:
                (item.serialNumber ? item.serialNumber + " - " : "") +
                (item.name ? item.name : ""),
            };
          });

          this.loadingaccesscontrolcodes = false;
        }
      } catch (err) {
        this.loadingaccesscontrolcodes = false;
        console.log(err);
      }
    },
    externalDateInput() {
      this.extendThroughMenu = false;
      let date = moment(this.externalDate).format("MM/DD/YYYY");
      this.selectedItem.extendrentaldate = date;
    },
    callOffDateInput() {
      this.callOffRentMenu = false;
      let date = moment(this.callOffDate).format("MM/DD/YYYY");
      this.selectedItem.calloffdate = date;
    },
    moveJobSiteDateInput() {
      this.moveOnMenu = false;
      let date = moment(this.moveJobSiteDate).format("MM/DD/YYYY");
      this.selectedItem.movejobsitedate = date;
    },
    serviceMaintenanceDateInput() {
      this.serviceOnMenu = false;
      let date = moment(this.maintenanceDate).format("MM/DD/YYYY");
      this.selectedItem.requestmaintenancedate = date;
    },
    direction(item) {
      this.$router.push("/?searchkey=" + encodeURIComponent(item.stockKey));
    },
    accessControlCodeChange() {
      this.selectedAccessControlCodesNames = [];
      this.selectedAccessControlCodesNames =
        this.selectedAccessControlCodes.map(
          (serialNumber) =>
            this.accessControlCodes.find(
              (el) => el.serialNumber == serialNumber
            ).showCodeName
        );
    },
    resetAccessControlCodes() {
      this.selectedAccessControlCodes = [];
      this.selectedAccessControlCodesNames = [];
    },
    clearSearch() {
      this.searchField = "";
    },
    OnOwnerTypeChange() {
      this.selectedOwnershipFinal = this.computeOwnershipFinal(
        this.selectedOwnershipType
      );
    },
    resetOwnerType() {
      this.selectedOwnershipType = ["1", "2"];
      this.selectedOwnershipFinal = "0";
    },
    async readReportListFromAPI() {
      this.reportDataList = [];
      this.isReportLoading = true;
      //All Reports Filters
      let machineIds, zone, groupIds, jobSite, model;
      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      let accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      //End Report Filters
      try {
        let response = await telematicsService.getOnReportList(
          Number(this.selectedOwnershipFinal),
          machineIds,
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue,
          this.pageNumber,
          -1
        );
        if (response.isSuccess) {
          this.isReportLoading = false;
          this.reportDataList = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
            calloffdate: "",
            calloffrent: false,
            extendrentaldate: "",
            extendrental: false,
            movejobsitedate: "",
            movejobsitenewnum: "",
            movejobsite: false,
            requestmaintenancecontact: "",
            requestmaintenancecontactphone: "",
            requestmaintenance: false,
          }));
          this.totalRecordsCount = response.totalRecords;
          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
        } else {
          this.isReportLoading = false;
          this.reportDataList = [];
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    pageChange() {
      this.readReportListFromAPI();
    },
    async readReportListFromAPIExport() {
      this.isDownloading = true;
      let date1 = "";
      let date2 = "";
      date1 = this.fromDate;
      date2 = this.toDate;
      let machineIds, zone, groupIds, jobSite, model;
      date1 = this.fromDate;
      date2 = this.toDate;
      let accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      try {
        let response = await telematicsService.getOnReportListExport(
          Number(this.selectedOwnershipFinal),
          date1,
          date2,
          machineIds,
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue
        );
        if (response) {
          this.downloadFile(response);
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
        this.isDownloading = false;
      }
    },
    async readReportListFromApiPdf() {
      this.isDownloading = true;
      let date1 = "";
      let date2 = "";
      date1 = this.fromDate;
      date2 = this.toDate;
      let machineIds, zone, groupIds, jobSite, model;
      date1 = this.fromDate;
      date2 = this.toDate;
      let accessControlCodes = this.joinOrEmpty(this.selectedAccessControlCodes);
      let searchValue = "";
      if (this.searchField) {
        searchValue = this.searchField;
      } else {
        searchValue = "";
      }
      let searchContractValue = "";
      if (this.searchContractId) {
        searchContractValue = this.searchContractId;
      } else {
        searchContractValue = "";
      }
      machineIds = this.joinOrEmpty(this.selectedMachine, true);
      groupIds = this.joinOrEmpty(this.selectedGroup);
      model = this.joinOrEmpty(this.selectedModel);
      jobSite = this.joinOrEmpty(this.selectedJobSite);
      zone = this.joinOrEmpty(this.selectedZone);
      try {
        let response = await telematicsService.getOnRentReportListPDF(
          Number(this.selectedOwnershipFinal),
          date1,
          date2,
          machineIds,
          zone,
          groupIds,
          jobSite,
          accessControlCodes,
          model,
          searchValue,
          searchContractValue
        );
        if (response) {
          this.downloadFilePDF(response);
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
        this.isDownloading = false;
      }
    },
    downloadFilePDF(apiResult) {
      if (apiResult) {
        this.triggerDownload(apiResult, "On rent Report.pdf", "application/pdf");
      } else {
        this.isDownloading = false;
      }
    },
    downloadFile(response) {
      this.triggerDownload(
        response,
        "On Rent Report.xlsx",
        "application/vnd.ms-excel"
      );
    },

    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.readReportListFromAPIExport();
        }
        //case  "Pdf"
        else if (this.selectedExportOption == this.exportOptions[1]) {
          this.readReportListFromApiPdf();
        }
      }
    },
    async getJobSites() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = response.data.filter(
            (e) => e.locationName != null
          );
        } else {
          this.jobSiteList = [];
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    getFirstPageData() {
      this.pageNumber = 1;
      this.pageSize = 100;
      this.readReportListFromAPI();
    },
    getLastPageData() {
      this.pageNumber = this.totalRecords;
      this.pageSize = 100;
      this.readReportListFromAPI();
    },
    openActionsDialog(item) {
      this.actionsDialog = true;
      let name = item.name ? item.name : "";
      let key = item.stockKey ? item.stockKey : "";
      this.dialogTitle = name + " - " + key;
      this.selectedItem = item;
    },
    clearActionFields() {
      this.dialogTitle = "";
      this.extendThroughMenu = false;
      this.callOffRentMenu = false;
      this.moveOnMenu = false;
      this.serviceOnMenu = false;
      this.selectedItem = {};
      this.actionsDialog = false;
    },
    closeActionsDilaog() {
      this.actionsDialog = false;
      this.clearActionFields();
    },
    cancelItemEdit() {
      this.actionsDialog = false;
      this.dialogTitle = "";
      this.extendThroughMenu = false;
      this.callOffRentMenu = false;
      this.moveOnMenu = false;
      this.serviceOnMenu = false;
      // clear out the values
      if (this.selectedEquipments.includes(this.selectedItem.equipmentId)) {
        var index = this.selectedEquipments.indexOf(
          this.selectedItem.equipmentId
        );
        if (index !== -1) {
          this.selectedEquipments.splice(index, 1);
        }
      }
      this.selectedItem.extendrental = false;
      this.selectedItem.extendrentaldate = "";

      this.selectedItem.calloffrent = false;
      this.selectedItem.calloffdate = "";

      this.selectedItem.movejobsite = false;
      this.selectedItem.movejobsitedate = "";
      this.selectedItem.movejobsitenewnum = "";

      this.selectedItem.requestmaintenance = false;
      this.selectedItem.requestmaintenancecontact = "";
      this.selectedItem.requestmaintenancecontactphone = "";
      this.selectedItem.requestmaintenancedate = "";
      this.requestCount--;
      this.selectedItem = {
        extendrental: false,
        extendrentaldate: "",
        calloffrent: false,
        calloffdate: "",
        movejobsite: false,
        movejobsitedate: "",
        movejobsitenewnum: "",
        requestmaintenance: false,
        requestmaintenancecontact: "",
        requestmaintenancecontactphone: "",
        requestmaintenancedate: "",
      };
      this.externalDate = "";
      this.callOffDate = "";
      this.moveJobSiteDate = "";
      this.maintenanceDate = "";
    },
    saveItemEdit(value) {
      if (this.selectedItem.extendrentaldate) {
        this.selectedItem.extendrental = true;
      }
      if (this.selectedItem.calloffdate) {
        this.selectedItem.calloffrent = true;
      }

      if (this.selectedItem.movejobsitedate) {
        this.selectedItem.movejobsite = true;
      }

      if (
        this.selectedItem.requestmaintenancecontact &&
        this.selectedItem.requestmaintenancecontact.length > 0
      ) {
        this.selectedItem.requestmaintenance = true;
      }
      if (!this.selectedEquipments.includes(this.selectedItem.equipmentId)) {
        this.requestCount++;
        this.selectedEquipments.push(this.selectedItem.equipmentId);
      }
      this.actionsDialog = false;
      if (value) {
        this.emailRequestsClick();
      }
    },
    clearChecks() {
      // if everything worked clear all the checkboxes
      this.reportDataList.forEach((r) => {
        r.extendrental = false;
        r.extendrentaldate = "";
        r.calloffrent = false;
        r.callOffDate = "";
        r.movejobsite = false;
        r.movejobsitedate = "";
        r.movejobsitenewnum = "";
        r.requestmaintenance = false;
        r.requestMaintenanceContact = "";
        r.requestMaintenanceContactPhone = "";
        r.requestmaintenancedate = "";
      });
      this.selectedEquipments = [];
    },
    emailRequestsClick() {
      let actionItems = [];
      this.reportDataList.forEach((r) => {
        if (r.extendrental === true) {
          let data = [];
          data.push(r.extendrentaldate);
          let obj = {};
          obj = {
            contractId: r.contractId,
            actionType: "ExtendRental",
            itemKey: r.stockKey,
            itemName: r.name,
            date: moment(r.extendrentaldate).format("YYYY-MM-DD"),
          };
          actionItems.push(obj);
        }
        if (r.calloffrent === true) {
          let data = [];
          data.push(r.calloffdate);
          let obj = {};
          obj = {
            contractId: r.contractId,
            actionType: "CallOffRent",
            itemKey: r.stockKey,
            itemName: r.name,
            date: moment(r.calloffdate).format("YYYY-MM-DD"),
          };
          actionItems.push(obj);
        }
        if (r.movejobsite === true) {
          let data = [];
          data.push(r.movejobsitedate);
          data.push(r.movejobsitenewnum);
          let obj = {};
          obj = {
            contractId: r.contractId,
            actionType: "MoveJobSite",
            itemKey: r.stockKey,
            itemName: r.name,
            date: moment(r.movejobsitedate).format("YYYY-MM-DD"),
            jobSiteId: r.movejobsitenewnum,
          };
          actionItems.push(obj);
        }
        if (r.requestmaintenance === true) {
          let data = [];
          data.push(r.requestmaintenancedate);
          data.push(r.requestmaintenancecontact);
          data.push(r.requestmaintenancecontactphone);
          let obj = {};
          obj = {
            contractId: r.contractId,
            actionType: "RequestMaintenance",
            itemKey: r.stockKey,
            itemName: r.name,
            date: moment(r.requestmaintenancedate).format("YYYY-MM-DD"),
            contactName: r.requestmaintenancecontact,
            contactPhone: r.requestmaintenancecontactphone,
          };
          actionItems.push(obj);
        }
      });
      if (actionItems.length > 0) {
        this.sendActionEmails(actionItems);
      } else {
        this.$toast.error("Error sending action emails");
      }
    },
    async sendActionEmails(actionItems) {
      this.isSendEmail = true;
      try {
        let response = await smsServiceNew.sendOnRentEmailToBirch(actionItems);
        if (response) {
          this.isSendEmail = false;
          this.$toast.success("Email sent successfully");
          this.clearChecks();
          this.readReportListFromAPI();
          this.requestCount = 0;
          this.showDialog = false;
          if (this.$route.name != this.toRoute) {
            this.$router.push({ name: this.toRoute }).catch(() => {});
          }
        } else {
          this.isSendEmail = false;
          this.$toast.error("Unable send email");
        }
      } catch (err) {
        this.isSendEmail = false;
        this.$toast.error("Unable send email");
        console.log(err);
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.cancelItemEdit();
      if (this.$route.name != this.toRoute) {
        this.$router.push({ name: this.toRoute }).catch(() => {});
      }
    },
    //All Report Filter Methods
    async getMachines() {
      try {
        this.loading = true;
        let response = await telematicsService.getMachines();
        if (response && response.data) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data.filter((e) => e.locationName != null);
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
    },
    resetGroup() {
      (this.selectedGroup = []), (this.reportDataList = []);
    },
    resetMachine() {
      (this.selectedMachine = []), (this.reportDataList = []);
    },
    resetZone() {
      this.selectedZone = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
    },
    resetModel() {
      this.selectedModel = [];
    },
    clearFilters() {
      this.selectedOwnershipType = ["1", "2"];
      this.selectedOwnershipFinal = "0";
      this.fromDate = "";
      this.toDate = "";
      this.reportDataList = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.searchField = "";
      this.selectedAccessControlCodesNames = [];
      this.selectedAccessControlCodes = [];
      this.searchContractId = "";
      this.readReportListFromAPI();
    },
    // scheduled reports api calls

    zoneChangeSchedule() {
      this.selectedZonesNamesSchedule = [];
      this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    jobSiteChangeSchedule() {
      this.selectedJobSiteNamesSchedule = [];
      this.selectedJobSiteNamesSchedule = this.selectedJobSiteSchedule.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
    modelChangeSchedule() {
      this.selectedModelNamesSchedule = [];
      this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    accessControlCodeChangeSchedule() {
      this.selectedAccessControlCodesNamesSchedule = [];
      this.selectedAccessControlCodesNamesSchedule =
        this.selectedAccessControlCodesSchedule.map(
          (serialNumber) =>
            this.accessControlCodes.find(
              (el) => el.serialNumber == serialNumber
            ).showCodeName
        );
    },

    resetGroupSchedule() {
      this.selectedGroupSchedule = [];
    },

    resetZoneSchedule() {
      this.selectedZoneSchedule = [];
      this.selectedZonesNamesSchedule = [];
    },
    resetJobSiteSchedule() {
      this.selectedJobSiteSchedule = [];

      this.selectedJobSiteNamesSchedule = [];
    },
    resetAccessControlCodesSchedule() {
      this.selectedAccessControlCodesSchedule = [];
      this.selectedAccessControlCodesNamesSchedule = [];
    },
    resetModelSchedule() {
      this.selectedModelSchedule = [];
      this.selectedModelNamesSchedule = [];
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    showScheduledForm() {
      this.readUsersFromAPI();
      this.scheduleedit = false;
      this.clearSchedule();
      this.displayScheduledForm = true;
    },
    showAlertsForm() {
      this.alertsedit = false;
      this.clearAlerts();
      this.displayAlertsForm = true;
    },
    cancelSchedule() {
      this.displayScheduledForm = false;
      this.scheduleedit = false;
      this.selectMonthlyDay = null;

      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledType = "";
      this.resetJobSiteSchedule();
      this.resetModelSchedule();
      this.resetAccessControlCodesSchedule();
      this.resetGroupSchedule();
      this.resetZoneSchedule();
      this.searchFieldSchedule = "";
      this.searchContractIdSchedule = "";
    },
    cancelAlerts() {
      this.displayAlertsForm = false;
      this.alertsedit = false;

      this.selectedalerts = {};
      this.alertName = "";
      this.alertsemails = [];
      this.selectedalertsdays = [];
    },
    closeSchedule() {
      this.scheduledialog = false;
      this.clearSchedule();
    },
    closeAlerts() {
      this.alertsdialog = false;
      this.clearAlerts();
    },
    clearSchedule() {
      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.selectedUser = "";
      this.scheduledFrequency = "";
      this.scheduledType = "";
      this.selectMonthlyDay = null;

      this.resetJobSiteSchedule();
      this.resetModelSchedule();
      this.resetAccessControlCodesSchedule();
      this.resetGroupSchedule();
      this.resetZoneSchedule();
      this.searchFieldSchedule = "";
      this.searchContractIdSchedule = "";
    },
    async CreateAlerts() {
      this.isSaveAlertsLoading = true;
      let id, cust;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        cust = "";
        id = "";
      } else {
        cust = this.$store.getters.companyNameDropdown;
        id = this.$store.getters.companyIdDropdown;
      }
      let parameters = [];
      let alertsemails = this.alertsemails.map((e) => e.trim());
      let payload = {
        reportId: this.AlertsReportName,
        parameters: parameters,
        customer: String(id),
        customerName: cust,
        name: this.alertsName,
        emails: alertsemails.join(","),
        weekDays:
          this.selectedalertsdays.length != 0
            ? this.selectedalertsdays.toString()
            : null,
        frequency: "Daily",
        format: "Excel",
      };
      try {
        let response = await telematicsService.createScheduledReport(payload);
        if (response.isSuccess) {
          this.isSaveAlertsLoading = false;
          this.$toast.success(" Alerts report  created successfully");
          this.displayAlertsForm = false;
          this.getAlertsList();
        } else {
          this.isSaveAlertsLoading = false;
          this.reportDataList = [];
        }
      } catch (err) {
        console.log(err);
        this.isSaveAlertsLoading = false;
      }
    },
    async UpdateAlerts() {
      this.isupdateAlertsLoading = true;

      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }
      let parameters = [];
      let alertsemails = this.alertsemails.map((e) => e.trim());
      let payload = {
        id: this.selectedalerts.id,
        reportId: this.AlertsReportName,
        parameters: parameters,
        customer: String(id),
        customerName: this.selectedcustalert,
        name: this.alertsName,
        emails: alertsemails.join(","),
        frequency: "Daily",
        format: "Excel",
        weekDays:
          this.selectedalertsdays.length != 0
            ? this.selectedalertsdays.toString()
            : null,
      };
      try {
        let response = await telematicsService.updateAlertsReport(
          this.selectedalerts.id,
          payload
        );
        if (response.isSuccess) {
          this.isupdateAlertsLoading = false;
          this.$toast.success(" Alerts report  updated successfully");
          this.displayAlertsForm = false;
          this.getAlertsList();
        } else {
          this.isupdateAlertsLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isupdateAlertsLoading = false;
      }
    },

    clearAlerts() {
      this.selectedalerts = {};
      this.alertsName = "";
      this.alertsemails = [];

      this.selectedalertsdays = [];
    },
    openScheduledDialog() {
      this.displayScheduledForm = false;
      this.scheduledialog = true;
      this.getScheduledList();
    },
    openAlertsDialog() {
      this.displayAlertsForm = false;
      this.alertsdialog = true;
      this.getAlertsList();
    },
    EditScheduleDialog(item) {
      this.scheduleedit = true;
      this.readUsersFromAPI();
      this.selectedschedule = item;
      this.selectedcust = item.customerName;
      this.selectedUser = item.requestUserId;

      this.scheduleName = item.name;
      this.emails = item.emails.split(",");
      this.selectedDays =
        item.weekDays != null && item.weekDays != ""
          ? item.weekDays.split(",")
          : [];
      this.selectMonthlyDay =
        item.day != null && item.day != "" ? item.day : null;
      this.scheduledFrequency = item.frequency;
      this.scheduledType = item.format;
      this.displayScheduledForm = true;
      // filters

      item.parameters.filter((e) => {
        if (e.name == "groupIds" && e.value != "") {
          this.selectedGroupSchedule = e.value.split(",");
        }
        if (e.name == "zone" && e.value != "") {
          this.selectedZoneSchedule = e.value.split(",");
          this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
            (id) => this.zonesList.find((el) => el.id == id).name
          );
        }
        if (e.name == "model" && e.value != "") {
          this.selectedModelSchedule = e.value.split(",");
          this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
            (id) => this.models.find((el) => el.id == id).name
          );
        }
        if (e.name == "jobSite" && e.value != "") {
          this.selectedJobSiteSchedule = e.value.split(",");
          this.selectedJobSiteNamesSchedule = this.selectedJobSiteSchedule.map(
            (locationId) =>
              this.locations.find((el) => el.locationId == locationId)
                .locationName
          );
        }
        if (e.name == "accessCodes" && e.value != "") {
          this.selectedAccessControlCodesSchedule = e.value.split(",");
          this.selectedAccessControlCodesNamesSchedule =
            this.selectedAccessControlCodesSchedule.map(
              (serialNumber) =>
                this.accessControlCodes.find(
                  (el) => el.serialNumber == serialNumber
                ).showCodeName
            );
        }
        if (e.name == "searchKey" && e.value != "") {
          this.searchFieldSchedule = e.value;
        }
        if (e.name == "contractId" && e.value != "") {
          this.searchContractIdSchedule = e.value;
        }
      });

      //end filters
    },
    EditAlertsDialog(item) {
      this.alertsedit = true;
      this.selectedalerts = item;
      this.selectedcustalert = item.customerName;

      this.alertsName = item.name;

      this.alertsemails = item.emails.split(",");
      this.selectedalertsdays =
        item.weekDays != null && item.weekDays != ""
          ? item.weekDays.split(",")
          : [];
      this.displayAlertsForm = true;
      // filters

      item.parameters.filter((e) => {
        if (e.name == "groupIds" && e.value != "") {
          this.selectedGroupSchedule = e.value.split(",");
        }
        if (e.name == "zone" && e.value != "") {
          this.selectedZoneSchedule = e.value.split(",");
          this.selectedZonesNamesSchedule = this.selectedZoneSchedule.map(
            (id) => this.zonesList.find((el) => el.id == id).name
          );
        }
        if (e.name == "model" && e.value != "") {
          this.selectedModelSchedule = e.value.split(",");
          this.selectedModelNamesSchedule = this.selectedModelSchedule.map(
            (id) => this.models.find((el) => el.id == id).name
          );
        }
        if (e.name == "jobSite" && e.value != "") {
          this.selectedJobSiteSchedule = e.value.split(",");
          this.selectedJobSiteNamesSchedule = this.selectedJobSiteSchedule.map(
            (locationId) =>
              this.locations.find((el) => el.locationId == locationId)
                .locationName
          );
        }
        if (e.name == "accessCodes" && e.value != "") {
          this.selectedAccessControlCodesSchedule = e.value.split(",");
          this.selectedAccessControlCodesNamesSchedule =
            this.selectedAccessControlCodesSchedule.map(
              (serialNumber) =>
                this.accessControlCodes.find(
                  (el) => el.serialNumber == serialNumber
                ).showCodeName
            );
        }
        if (e.name == "searchKey" && e.value != "") {
          this.searchFieldSchedule = e.value;
        }
        if (e.name == "contractId" && e.value != "") {
          this.searchContractIdSchedule = e.value;
        }
      });

      //end filters
    },
    async CreateSchedule() {
      this.isSaveScheduleLoading = true;
      let zone, groupIds, jobSite, model, accessControlCodes;

      groupIds = this.joinOrEmpty(this.selectedGroupSchedule);
      model = this.joinOrEmpty(this.selectedModelSchedule);
      accessControlCodes = this.joinOrEmpty(
        this.selectedAccessControlCodesSchedule
      );
      jobSite = this.joinOrEmpty(this.selectedJobSiteSchedule);
      zone = this.joinOrEmpty(this.selectedZoneSchedule);
      let searchValue = "";
      if (this.searchFieldSchedule) {
        searchValue = this.searchFieldSchedule;
      } else {
        searchValue = "";
      }

      let searchContractValue = "";
      if (this.searchContractIdSchedule) {
        searchContractValue = this.searchContractIdSchedule;
      } else {
        searchContractValue = "";
      }
      let id, cust;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        cust = "";
        id = "";
      } else {
        cust = this.$store.getters.companyNameDropdown;
        id = this.$store.getters.companyIdDropdown;
      }
      let parameters = [
        {
          name: "groupIds",
          value: groupIds,
        },
        {
          name: "zone",
          value: zone,
        },
        {
          name: "model",
          value: model,
        },
        {
          name: "jobSite",
          value: jobSite,
        },
        {
          name: "accessCodes",
          value: accessControlCodes,
        },
        {
          name: "searchKey",
          value: searchValue,
        },
        {
          name: "contractId",
          value: searchContractValue,
        },
        {
          name: "pageNumber",
          value: "1",
        },
        {
          name: "pageSize",
          value: "-1",
        },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        reportId: this.ScheduleReportName,
        parameters: parameters,
        customer: String(id),
        customerName: cust,
        name: this.scheduleName,
        emails: emails.join(","),
        requestUserId: this.selectedUser != null ? this.selectedUser : "",

        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        frequency: this.scheduledFrequency,
        format: this.scheduledType,
        day:
          this.selectMonthlyDay != null && this.selectMonthlyDay != ""
            ? this.selectMonthlyDay
            : null,
      };
      try {
        let response = await telematicsService.createScheduledReport(payload);
        if (response.isSuccess) {
          this.isSaveScheduleLoading = false;
          this.$toast.success(" Schedule report  created successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isSaveScheduleLoading = false;
          this.reportDataList = [];
        }
      } catch (err) {
        console.log(err);
        this.isSaveScheduleLoading = false;
      }
    },
    async UpdateSchedule() {
      this.isupdateScheduleLoading = true;
      let zone, groupIds, jobSite, model, accessControlCodes;

      groupIds = this.joinOrEmpty(this.selectedGroupSchedule);
      model = this.joinOrEmpty(this.selectedModelSchedule);
      accessControlCodes = this.joinOrEmpty(
        this.selectedAccessControlCodesSchedule
      );
      jobSite = this.joinOrEmpty(this.selectedJobSiteSchedule);
      zone = this.joinOrEmpty(this.selectedZoneSchedule);
      let searchValue = "";
      if (this.searchFieldSchedule) {
        searchValue = this.searchFieldSchedule;
      } else {
        searchValue = "";
      }

      let searchContractValue = "";
      if (this.searchContractIdSchedule) {
        searchContractValue = this.searchContractIdSchedule;
      } else {
        searchContractValue = "";
      }
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }
      let parameters = [
        {
          name: "groupIds",
          value: groupIds,
        },
        {
          name: "zone",
          value: zone,
        },
        {
          name: "model",
          value: model,
        },
        {
          name: "jobSite",
          value: jobSite,
        },
        {
          name: "accessCodes",
          value: accessControlCodes,
        },
        {
          name: "searchKey",
          value: searchValue,
        },
        {
          name: "contractId",
          value: searchContractValue,
        },
        {
          name: "pageNumber",
          value: "1",
        },
        {
          name: "pageSize",
          value: "-1",
        },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        id: this.selectedschedule.id,
        reportId: this.ScheduleReportName,
        parameters: parameters,
        customer: String(id),
        customerName: this.selectedcust,
        name: this.scheduleName,
        emails: emails.join(","),
        requestUserId: this.selectedUser != null ? this.selectedUser : "",

        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        frequency: this.scheduledFrequency,
        format: this.scheduledType,
        day:
          this.selectMonthlyDay != null && this.selectMonthlyDay != ""
            ? this.selectMonthlyDay
            : null,
      };
      try {
        let response = await telematicsService.updateScheduledReport(
          this.selectedschedule.id,
          payload
        );
        if (response.isSuccess) {
          this.isupdateScheduleLoading = false;
          this.$toast.success(" Schedule report  updated successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isupdateScheduleLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isupdateScheduleLoading = false;
      }
    },

    async getScheduledList() {
      this.isScheduledListLoading = true;
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }
      try {
        let response = await telematicsService.getScheduledReportList(
          String(id),
          String(this.ScheduleReportName)
        );

        if (response.isSuccess) {
          this.isScheduledListLoading = false;
          this.scheduledList = response.data;
        } else {
          this.isScheduledListLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isScheduledListLoading = false;
      }
    },

    async getAlertsList() {
      this.isAlertsListLoading = true;
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }
      try {
        let response = await telematicsService.getScheduledReportList(
          String(id),
          String(this.AlertsReportName)
        );

        if (response.isSuccess) {
          this.isAlertsListLoading = false;
          this.AlertsList = response.data;
        } else {
          this.isAlertsListLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isAlertsListLoading = false;
      }
    },
    confirmDelete(item) {
      this.confirmdialog = true;
      this.selectedschedule = item;
    },
    confirmDeleteAlerts(item) {
      this.confirmdialog = true;
      this.selectedalerts = item;
    },
    async deleteSchedule() {
      try {
        this.isdelete = true;
        let response = await telematicsService.deleteSchedule(
          this.selectedschedule.id
        );
        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Deleted Schedule report successfully");
          this.clearSchedule();
          this.displayScheduledForm = false;
          this.getScheduledList();
          this.confirmdialog = false;
          this.selectedschedule = {};
        } else {
          this.isdelete = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Schedule report" + err);
      }
    },
    async deleteAlerts() {
      try {
        this.isdeletealerts = true;
        let response = await telematicsService.deleteAlerts(
          this.selectedalerts.id
        );
        if (response.isSuccess) {
          this.isdeletealerts = false;
          this.$toast.success("Deleted Schedule report successfully");
          this.clearAlerts();
          this.displayAlertsForm = false;
          this.getAlertsList();
          this.confirmdialog = false;
          this.selectedalerts = {};
        } else {
          this.isdeletealerts = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Schedule report" + err);
      }
    },
    OnFrequencyChange() {
      this.selectedDays = [];
      this.selectMonthlyDay = null;
    },
    // end scheduled reports methods
  },
};
